import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3914ee1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-section invoice" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Client/Landlord", -1))
const _hoisted_3 = { class: "form-group row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Landlord/Client name", -1))
const _hoisted_5 = { class: "col-sm-3" }
const _hoisted_6 = {
  key: 0,
  class: "error-message"
}
const _hoisted_7 = { class: "form-group row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "E-mail", -1))
const _hoisted_9 = { class: "col-sm-6" }
const _hoisted_10 = {
  key: 0,
  class: "error-message"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Customer", -1))
const _hoisted_12 = { class: "form-group row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Company", -1))
const _hoisted_14 = { class: "col-sm-3" }
const _hoisted_15 = { class: "form-group row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Branch", -1))
const _hoisted_17 = { class: "col-sm-3" }
const _hoisted_18 = { class: "form-group row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "C/o", -1))
const _hoisted_20 = { class: "col-sm-6" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "form-group row" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, [
  /*#__PURE__*/_createTextVNode("Address "),
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Line 1")
], -1))
const _hoisted_24 = { class: "col-sm-6" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "form-group row" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Address Line 2")
], -1))
const _hoisted_28 = { class: "col-sm-6" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { class: "form-group row" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "City", -1))
const _hoisted_32 = { class: "col-sm-3" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = { class: "form-group row" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "County", -1))
const _hoisted_36 = { class: "col-sm-3" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = { class: "form-group row" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Postcode", -1))
const _hoisted_40 = { class: "col-sm-2" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = { class: "form-group row" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "A/C Client Code", -1))
const _hoisted_44 = { class: "col-sm-4" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = { class: "form-group row" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Nominal Code", -1))
const _hoisted_48 = { class: "col-sm-4" }
const _hoisted_49 = ["disabled"]
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { class: "form-group row" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Feedback link active", -1))
const _hoisted_53 = { class: "col-sm-4" }
const _hoisted_54 = {
  key: 0,
  class: "form-group row"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Feedback link active for (Days)", -1))
const _hoisted_56 = { class: "col-sm-4" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Job Details", -1))
const _hoisted_58 = { class: "form-group row" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Works/Purchase order number", -1))
const _hoisted_60 = { class: "col-sm-4" }
const _hoisted_61 = { class: "row" }
const _hoisted_62 = { class: "col-sm-6" }
const _hoisted_63 = { class: "col-sm-12" }
const _hoisted_64 = {
  key: 0,
  class: "error-message"
}
const _hoisted_65 = { class: "form-group row" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 col-form-label" }, "Fees", -1))
const _hoisted_67 = { class: "col-sm-6" }
const _hoisted_68 = { class: "col-6" }
const _hoisted_69 = ["onUpdate:modelValue", "onChange", "placeholder"]
const _hoisted_70 = { class: "col-4" }
const _hoisted_71 = { class: "input-group" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "£")
], -1))
const _hoisted_73 = ["onChange", "onUpdate:modelValue", "disabled"]
const _hoisted_74 = { class: "col-1" }
const _hoisted_75 = ["onClick"]
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_77 = [
  _hoisted_76
]
const _hoisted_78 = ["disabled"]
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))

import { computed, ref, inject, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import { Fee, Customer, Dictionary, Report, Depository } from '@/models';
import { DxSwitch } from 'devextreme-vue/switch';
import { useEvent } from '@/eventBus';


export default /*#__PURE__*/_defineComponent({
  __name: 'Invoice',
  setup(__props) {

const store = useStore();
const actProperty: any = inject('actProperty');

const listofdays = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
  22, 23, 24, 25, 26, 27, 28, 29, 30,
];

const isAdministrator = computed(() => store.getters['auth/isAdministrator']);
const isCustomer = computed(() => store.getters['auth/isCustomer']);
const dictionary = computed(() => store.getters['dictionary/current']);
const statereport = computed(() => store.getters['reports/current']);

// Converting @Action to arrow functions
const setReportDeep = (payload: { path: string; data: any }): Promise<any> => {
  return store.dispatch('reports/setReportDeep', payload);
};

const getCustomers = (payload?: {
  starts_with?: string;
  company_name?: string;
  branch_name?: string;
}): Promise<Customer[]> => {
  return store.dispatch('customers/getCustomers', payload);
};

const getCompanyNameOptions = (): Promise<any> => {
  return store.dispatch('customers/getCompanyNameOptions');
};

const getBranchNameOptions = (companyName?: string): Promise<any> => {
  return store.dispatch('customers/getBranchNameOptions', companyName);
};

// Converting @Mutation to arrow functions
const setCurrentReportFlagged = (flagged: boolean): void => {
  store.commit('reports/setCurrentReportFlagged', flagged);
};

const setCurrentCOSMReportFlagged = (flaggedCOSM: boolean): void => {
  store.commit('reports/setCurrentCOSMReportFlagged', flaggedCOSM);
};

const setReportDeepWithoutCounting = (payload: {
  path: string;
  data: any;
}): Promise<any> => {
  return store.dispatch('reports/setReportDeepWithoutCounting', payload);
};

const companyNameOptions = ref<string[]>([]);
const branchNameOptions = ref<string[]>([]);

onMounted(() => {
  useEvent("reportLoadedOnEditReportPage", (report: Report) => {
    Promise.all([
      getCompanyNameOptions(),
      getBranchNameOptions(customerCompanyName.value),
    ])
      .then((values) => {
        companyNameOptions.value = values[0];
        branchNameOptions.value = values[1];
      })
      .catch((err) => {
        actProperty.displayError(err);
      });
  });
  
  store.subscribe((mutation, state) => {
    if (!isCustomer.value && mutation.type === "reports/setReport") {
      initFeedback();
    }
  });

  setTimeout(() => {
    if (!isCustomer.value && fees.value.length === 0) {
      setReportDeepWithoutCounting({ path: "fees", data: [new Fee()] });
    }
  }, 2000);
});

const clientName = computed({
  get: () => statereport.value.client.name,
  set: (data) => setReportDeep({ path: 'client.name', data })
});

// clientEmail
const clientEmail = computed({
  get: () => statereport.value.client.email,
  set: (data) => setReportDeep({ path: 'client.email', data })
});

// customerCompanyName
const customerCompanyName = computed({
  get: () => statereport.value.customer.companyName,
  set: (data) => setReportDeep({ path: 'customer.companyName', data })
});

// customerBranchId
const customerBranchId = computed({
  get: () => {
    return statereport.value.customerId
  },
  set: (data) => setReportDeep({ path: 'customerId', data })
});

// customerBranchName
const customerBranchName = computed({
  get: () => statereport.value.customer.branchName,
  set: (data) => setReportDeep({ path: 'customer.branchName', data })
});

// customerId
const customerId = computed({
  get: () => statereport.value.customer.id,
  set: (data) => setReportDeep({ path: 'customer.id', data })
});

// customerCo
const customerCo = computed({
  get: () => statereport.value.customer.co,
  set: (data) => setReportDeep({ path: 'customer.co', data })
});

// customerAddressLine1
const customerAddressLine1 = computed({
  get: () => statereport.value.customer.address.line1,
  set: (data) => setReportDeep({ path: 'customer.address.line1', data })
});

// customerAddressLine2
const customerAddressLine2 = computed({
  get: () => statereport.value.customer.address.line2,
  set: (data) => setReportDeep({ path: "customer.address.line2", data })
});

// customerAddressTown
const customerAddressTown = computed({
  get: () => statereport.value.customer.address.town,
  set: (data) => setReportDeep({ path: "customer.address.town", data })
});

// customerAddressCounty
const customerAddressCounty = computed({
  get: () => statereport.value.customer.address.county,
  set: (data) => setReportDeep({ path: "customer.address.county", data })
});

// customerAddressPostcode
const customerAddressPostcode = computed({
  get: () => statereport.value.customer.address.postcode,
  set: (data) => setReportDeep({ path: "customer.address.postcode", data })
});

// customerAcClientCode
const customerAcClientCode = computed({
  get: () => statereport.value.customer.acClientCode,
  set: (data) => setReportDeep({ path: "customer.acClientCode", data })
});

// customerNominalCode
const customerNominalCode = computed({
  get: () => statereport.value.customer.nominalCode,
  set: (data) => setReportDeep({ path: "customer.nominalCode", data })
});

// customerOffice
const customerOffice = computed({
  get: () => statereport.value.customer.office,
  set: (data) => setReportDeep({ path: "customer.office", data })
});

// feedbacklinkactive
const feedbacklinkactive = computed({
  get: () => statereport.value.customer.feedbacklinkactive,
  set: (data) => {
    if (!isCustomer.value && feedbacklinkactive.value !== data) {
      setReportDeep({ path: "customer.feedbacklinkactive", data });
    }
  }
});

// feedbacklinkactivedays
const feedbacklinkactivedays = computed({
  get: () => statereport.value.customer.feedbacklinkactivedays,
  set: (data) => {
    if (!isCustomer.value && feedbacklinkactivedays.value !== data) {
      setReportDeep({ path: "customer.feedbacklinkactivedays", data });
    }
  }
});

// workordernumberrequired
const workordernumberrequired = computed({
  get: () => statereport.value.customer.workordernumberrequired,
  set: (data) => setReportDeep({ path: "customer.workordernumberrequired", data })
});

// llnamerequired
const llnamerequired = computed({
  get: () => statereport.value.customer.accountsettings.llnamerequired,
  set: (data) => setReportDeep({ path: "customer.accountsettings.llnamerequired", data })
});

// llemailrequired
const llemailrequired = computed({
  get: () => statereport.value.customer.accountsettings.llemailrequired,
  set: (data) => setReportDeep({ path: "customer.accountsettings.llemailrequired", data })
});

// workorderNumber
const workorderNumber = computed({
  get: () => statereport.value.workorderNumber,
  set: (data) => setReportDeep({ path: "workorderNumber", data })
});

// redlinecoactive
const redlinecoactive = computed({
  get: () => statereport.value.customer.reportsettings.redlinecoactive,
  set: (data) => setReportDeep({ path: "customer.reportsettings.redlinecoactive", data })
});

// cosummaryactive
const cosummaryactive = computed({
  get: () => statereport.value.customer.reportsettings.cosummaryactive,
  set: (data) => setReportDeep({ path: "customer.reportsettings.cosummaryactive", data })
});

// cosmredlineactive
const cosmredlineactive = computed({
  get: () => statereport.value.customer.reportsettings.cosmredlineactive,
  set: (data) => setReportDeep({ path: "customer.reportsettings.cosmredlineactive", data })
});

// depository
const depository = computed({
  get: () => statereport.value.customer.depository,
  set: (depository) => setReportDeep({ path: "customer.depository", data: depository })
});

// editable
const editable = computed({
  get: () => statereport.value.customer.editable,
  set: (data) => setReportDeep({ path: "customer.editable", data })
});

// fees
const fees = computed({
  get: () => statereport.value.fees,
  set: (data) => setReportDeep({ path: "fees", data })
});

// hidefrontpageaddress
const hidefrontpageaddress = computed({
  get: () => statereport.value.customer.hidefrontpageaddress,
  set: (data) => setReportDeep({ path: "customer.hidefrontpageaddress", data })
});

// Add new Fee to Invoice
const addNewFee = () => {
  fees.value = fees.value.concat([new Fee()]);
};

// Remove Fee from Invoice
const removeFee = (index) => {
  actProperty.confirmPrompt()
    .then(() => {
      fees.value = actProperty.removeItemByIndex(fees.value, index);
    });
};

// Get Branch details when Company Name has been selected
const onSelectCompanyName = async (companyName) => {
  if (companyName) {
    branchNameOptions.value = await getBranchNameOptions(companyName);
  } else {
    customerCompanyName.value = "";
  }
  customerBranchId.value = undefined;
  customerBranchName.value = "";
  resetBranchDetails();
};

// Add Company Name as tag on Div
const onTagCompanyName = (val) => {
  customerCompanyName.value = val;
  onTagBranchName("");
};

// Get Branch details when Company Name has been selected
const onSelectBranchName = async (branchName) => {
  customerBranchName.value = branchName;

  if (!customerBranchName.value || !customerCompanyName.value) {
    return actProperty.displayError("Provide both a Company and a Branch");
  }

  const customers = await getCustomers({
    company_name: customerCompanyName.value,
    branch_name: customerBranchName.value,
  });

  if (customers.length) {
    setBranchDetails(customers[0]);
  } else {
    resetBranchDetails();
  }
};

// Add Branch Name as tag on Div
const onTagBranchName = (val) => {
  customerBranchName.value = val;
  customerBranchId.value = undefined;
  resetBranchDetails();
};

// Assuming the reactive properties and methods used are available in the scope

// Set Branch Details
const setBranchDetails = (customer) => {
  customerBranchId.value = customer.id;
  customerId.value = customer.id;
  customerOffice.value = customer.office;
  customerCo.value = customer.co;
  customerAddressLine1.value = customer.address.line1;
  customerAddressLine2.value = customer.address.line2;
  customerAddressTown.value = customer.address.town;
  customerAddressCounty.value = customer.address.county;
  customerAddressPostcode.value = customer.address.postcode;
  customerAcClientCode.value = customer.acClientCode;
  customerNominalCode.value = customer.nominalCode;
  feedbacklinkactive.value = customer.feedbacklinkactive;
  feedbacklinkactivedays.value = customer.feedbacklinkactivedays;
  workordernumberrequired.value = customer.workordernumberrequired;
  llnamerequired.value = customer.accountsettings.llnamerequired;
  llemailrequired.value = customer.accountsettings.llemailrequired;
  hidefrontpageaddress.value = customer.hidefrontpageaddress;

  cosummaryactive.value = customer.reportsettings.cosummaryactive;
  redlinecoactive.value = customer.reportsettings.redlinecoactive;
  setCurrentReportFlagged(customer.reportsettings.redlinecoactive);
  cosmredlineactive.value = customer.reportsettings.cosmredlineactive;
  setCurrentCOSMReportFlagged(customer.reportsettings.cosmredlineactive);
  depository.value = customer.depository;
  editable.value = customer.editable;
};

// Reset Branch Details
const resetBranchDetails = () => {
  customerCo.value = "";
  customerOffice.value = "";
  customerAddressLine1.value = "";
  customerAddressLine2.value = "";
  customerAddressTown.value = "";
  customerAddressCounty.value = "";
  customerAddressPostcode.value = "";
  customerAcClientCode.value = "";
  customerNominalCode.value = "";
  feedbacklinkactive.value = true;
  feedbacklinkactivedays.value = 22;
  workordernumberrequired.value = false;
  llemailrequired.value = false;
  hidefrontpageaddress.value = false;

  cosummaryactive.value = true;
  redlinecoactive.value = true;
  setCurrentReportFlagged(true);
  cosmredlineactive.value = false;
  setCurrentCOSMReportFlagged(false);
  editable.value = false;
};

// Initialize Feedback
const initFeedback = () => {
  if (!statereport.value.customer || (!customerCo.value && !customerAddressLine1.value)) {
    feedbacklinkactive.value = true;
    feedbacklinkactivedays.value = 22;
  }
};

// Check if the customer/branch is new
const isNewCustomer = () => {
  return customerCompanyName.value === "" || customerBranchId.value === undefined;
};

// Check if the customer/branch already exists
const isExistingCustomer = () => {
  return !isNewCustomer();
};

const editFee = (fee:Fee,index:Number) => {
 setReportDeep({
    path: `fees[${index}]`,
    data:fee
  });
}


return (_ctx: any,_cache: any) => {
  const _component_multiselect_text = _resolveComponent("multiselect-text")!
  const _component_singleselect_text = _resolveComponent("singleselect-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("fieldset", null, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((clientName).value = $event))
          }, null, 512), [
            [
              _vModelText,
              clientName.value,
              void 0,
              { lazy: true }
            ]
          ]),
          (llnamerequired.value && !clientName.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Landord name is required "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((clientEmail).value = $event))
          }, null, 512), [
            [_vModelText, clientEmail.value]
          ]),
          (llemailrequired.value && !clientEmail.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, " Landord e-mail is required "))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("fieldset", null, [
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_multiselect_text, {
            modelValue: customerCompanyName.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((customerCompanyName).value = $event)),
            value: customerCompanyName.value,
            options: companyNameOptions.value,
            "allow-empty": true,
            taggable: true,
            onTag: onTagCompanyName,
            onSelect: onSelectCompanyName
          }, _createSlots({ _: 2 }, [
            (customerCompanyName.value && customerCompanyName.value.length)
              ? {
                  name: "clear",
                  fn: _withCtx(() => [
                    _createElementVNode("i", {
                      onMousedown: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (onTagCompanyName('')), ["prevent","stop"])),
                      class: "multiselect__clear fa fa-times",
                      "aria-label": "Clear Company Name"
                    }, null, 32)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["modelValue", "value", "options"])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_multiselect_text, {
            modelValue: customerBranchName.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((customerBranchName).value = $event)),
            value: customerBranchName.value,
            options: branchNameOptions.value,
            "allow-empty": true,
            disabled: !customerCompanyName.value || customerCompanyName.value.length < 1,
            taggable: true,
            onTag: onTagBranchName,
            onSelect: onSelectBranchName
          }, _createSlots({ _: 2 }, [
            (customerBranchName.value && customerBranchName.value.length)
              ? {
                  name: "clear",
                  fn: _withCtx(() => [
                    _createElementVNode("i", {
                      onMousedown: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (onTagBranchName('')), ["prevent","stop"])),
                      class: "multiselect__clear fa fa-times",
                      "aria-label": "Clear Branch Name"
                    }, null, 32)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["modelValue", "value", "options", "disabled"])
        ])
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "hidden",
        class: "form-control",
        disabled: "",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((customerBranchId).value = $event))
      }, null, 512), [
        [
          _vModelText,
          customerBranchId.value,
          void 0,
          { lazy: true }
        ]
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            disabled: isExistingCustomer() && !statereport.value.customer.editable,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((customerCo).value = $event))
          }, null, 8, _hoisted_21), [
            [
              _vModelText,
              customerCo.value,
              void 0,
              { lazy: true }
            ]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createElementVNode("div", _hoisted_24, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            disabled: isExistingCustomer() && !statereport.value.customer.editable,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((customerAddressLine1).value = $event))
          }, null, 8, _hoisted_25), [
            [
              _vModelText,
              customerAddressLine1.value,
              void 0,
              { lazy: true }
            ]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _createElementVNode("div", _hoisted_28, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            disabled: isExistingCustomer() && !statereport.value.customer.editable,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((customerAddressLine2).value = $event))
          }, null, 8, _hoisted_29), [
            [
              _vModelText,
              customerAddressLine2.value,
              void 0,
              { lazy: true }
            ]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _hoisted_31,
        _createElementVNode("div", _hoisted_32, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            disabled: isExistingCustomer() && !statereport.value.customer.editable,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((customerAddressTown).value = $event))
          }, null, 8, _hoisted_33), [
            [
              _vModelText,
              customerAddressTown.value,
              void 0,
              { lazy: true }
            ]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _hoisted_35,
        _createElementVNode("div", _hoisted_36, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            disabled: isExistingCustomer() && !statereport.value.customer.editable,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((customerAddressCounty).value = $event))
          }, null, 8, _hoisted_37), [
            [
              _vModelText,
              customerAddressCounty.value,
              void 0,
              { lazy: true }
            ]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_38, [
        _hoisted_39,
        _createElementVNode("div", _hoisted_40, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            disabled: isExistingCustomer() && !statereport.value.customer.editable,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((customerAddressPostcode).value = $event))
          }, null, 8, _hoisted_41), [
            [
              _vModelText,
              customerAddressPostcode.value,
              void 0,
              { lazy: true }
            ]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_42, [
        _hoisted_43,
        _createElementVNode("div", _hoisted_44, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            disabled: isExistingCustomer() && !statereport.value.customer.editable,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((customerAcClientCode).value = $event))
          }, null, 8, _hoisted_45), [
            [
              _vModelText,
              customerAcClientCode.value,
              void 0,
              { lazy: true }
            ]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_46, [
        _hoisted_47,
        _createElementVNode("div", _hoisted_48, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            disabled: isExistingCustomer() && !statereport.value.customer.editable,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((customerNominalCode).value = $event))
          }, null, 8, _hoisted_49), [
            [
              _vModelText,
              customerNominalCode.value,
              void 0,
              { lazy: true }
            ]
          ])
        ])
      ]),
      (!isExistingCustomer())
        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _hoisted_52,
              _createElementVNode("div", _hoisted_53, [
                _createVNode(_unref(DxSwitch), {
                  modelValue: feedbacklinkactive.value,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((feedbacklinkactive).value = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            (feedbacklinkactive.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                  _hoisted_55,
                  _createElementVNode("div", _hoisted_56, [
                    _createVNode(_component_singleselect_text, {
                      modelValue: feedbacklinkactivedays.value,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((feedbacklinkactivedays).value = $event)),
                      value: feedbacklinkactivedays.value,
                      options: listofdays
                    }, null, 8, ["modelValue", "value"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("fieldset", null, [
      _hoisted_57,
      _createElementVNode("div", _hoisted_58, [
        _hoisted_59,
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((workorderNumber).value = $event))
              }, null, 512), [
                [_vModelText, workorderNumber.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_63, [
              (workordernumberrequired.value && !workorderNumber.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_64, " Works/Purchase order number is required "))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_65, [
        _hoisted_66,
        _createElementVNode("div", _hoisted_67, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fees.value, (fee, $index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: fee._uuid,
              class: "row mb-3"
            }, [
              _createElementVNode("div", _hoisted_68, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": ($event: any) => ((fee.name) = $event),
                  onChange: ($event: any) => (editFee(fee,$index)),
                  placeholder: 
                  $index === 0
                    ? _unref(actProperty).formatReportType(statereport.value.type, dictionary.value)
                    : ''
                
                }, null, 40, _hoisted_69), [
                  [
                    _vModelText,
                    fee.name,
                    void 0,
                    { lazy: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("div", _hoisted_71, [
                  _hoisted_72,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    size: "6",
                    onChange: ($event: any) => (editFee(fee,$index)),
                    "onUpdate:modelValue": ($event: any) => ((fee.amount) = $event),
                    disabled: !customerBranchName.value || !customerBranchName.value.length
                  }, null, 40, _hoisted_73), [
                    [
                      _vModelText,
                      fee.amount,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_74, [
                ($index !== 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-outline-danger",
                      onClick: ($event: any) => (removeFee($index)),
                      tabindex: "-1"
                    }, _hoisted_77, 8, _hoisted_75))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128)),
          _createElementVNode("button", {
            class: "btn btn-primary",
            ref: "defaultFee",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (addNewFee())),
            disabled: !customerBranchName.value || !customerBranchName.value.length
          }, [
            _hoisted_79,
            _createTextVNode(" Fees ")
          ], 8, _hoisted_78)
        ])
      ])
    ])
  ]))
}
}

})